import React from 'react';
import PropTypes from 'prop-types';
import RepeatGroup from './ui/RepeatGroup';

class ProductModalDrips extends React.Component{
    render() {
        const drips = this.props.product.categoryDrips;
        let dripRepeatGroups = [];
        if(drips){ 
            dripRepeatGroups =  Object.keys(drips).map(drip => {
                if(drips[drip]) {
                    return(
                        <RepeatGroup fieldName="Category name" key={drip} id={drip} keyName={drips[drip].catName || ''} value={drips[drip].catTags || ''} onChange={(id, drip) => this.props.updateDrip('categoryDrips', id, drip)} onRemove={(id)=> this.props.removeDrip('categoryDrips', id)}/>
                    );
                }
                return null;
            });
        } 

        return (
            <div className="tab-panel">
                <div className="column column-wide">
                    { dripRepeatGroups }
                    <a onClick={e => this.props.addDrip('categoryDrips')} className="btn-add"><i className="material-icons">add_circle_outline</i>Add new</a>
                </div>
            </div>
        );
    }
}

ProductModalDrips.propTypes = {
    product: PropTypes.object.isRequired,
    addDrip: PropTypes.func.isRequired,
    updateDrip: PropTypes.func.isRequired,
    removeDrip: PropTypes.func.isRequired
}

export default ProductModalDrips;


/** WEBPACK FOOTER **
 ** ./src/components/ProductModalDrips.js
 **/